import { testimonials } from '@/mocks/testimonials';

export default function Testimonials() {
  return (
    <section className="py-16 md:py-24 bg-secondary-50">
      <div className="px-6 md:px-10 max-w-[1280px] mx-auto">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-2 mb-4">
            <span className="w-2 h-2 rounded-full bg-accent-500"></span>
            <span className="text-xs font-medium text-accent-600 bg-accent-50 border border-accent-200/60 px-3 py-1 rounded-full">
              读者评价
            </span>
          </div>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            百万读者的共同选择
          </h2>
          <p className="text-foreground-600 text-sm max-w-[500px] mx-auto">
            听听炮渣漫画网的忠实读者们怎么说
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {testimonials.map((t, index) => (
            <div
              key={t.id}
              className={`bg-background-50 rounded-xl p-6 ${
                index === testimonials.length - 1 ? 'opacity-60' : ''
              }`}
            >
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                ))}
              </div>
              <h4 className="font-heading font-bold text-foreground-900 mb-3 text-sm">
                {t.name}的推荐
              </h4>
              <p className="text-sm text-foreground-600 leading-relaxed mb-5">
                {t.content}
              </p>
              <div className="flex items-center gap-3">
                <img
                  src={t.avatar}
                  alt={t.name}
                  className="w-10 h-10 rounded-full object-cover"
                />
                <div>
                  <p className="text-sm font-semibold text-foreground-800">{t.name}</p>
                  <p className="text-xs text-foreground-500">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}